export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10289.ce7dc7ca.jpg";